// REACT
import { useContext } from 'react';

// CONTEXT
import { maincontext } from '../../context/maincontext';

// ASSETS
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import languagePack from "../../assets/languages/languagePack";

export default function RoleRestrictionModal({ onConfirm }) {
    const { language } = useContext(maincontext);

    return (
        <Modal show backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>
                    {languagePack[language].restrictedModal.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {languagePack[language].restrictedModal.body}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onConfirm}>
                    {languagePack[language].restrictedModal.footer}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
